import api from './api.js';

/**
 * Authentication Service
 * Handles all authentication-related API calls
 */

export const authService = {
  /**
   * Register new user
   * @param {Object} userData - { email, password, name }
   */
  register: async (userData) => {
    const response = await api.post('/auth/register', userData, {
      withCredentials: true, // Include cookies
    });
    return response;
  },

  /**
   * Login user
   * @param {Object} credentials - { email, password }
   */
  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials, {
      withCredentials: true, // Include cookies
    });
    return response;
  },

  /**
   * Logout user
   */
  logout: async () => {
    const response = await api.post('/auth/logout', {}, {
      withCredentials: true,
    });
    return response;
  },

  /**
   * Refresh access token
   */
  refreshToken: async () => {
    const response = await api.post('/auth/refresh', {}, {
      withCredentials: true,
    });
    return response;
  },

  /**
   * Get current user
   */
  getMe: async () => {
    const response = await api.get('/auth/me', {
      withCredentials: true,
    });
    return response;
  },
};
